import { logger } from '@/lib/logger';
import { track } from '@/lib/mixpanel';

import type { ChatRunContext, ChatRunHandlers } from './chatProgressPoll';
import { showChatRunCompleteToast } from './showChatRunCompleteToast';
import { showChatRunFailureToast } from './showChatRunFailureToast';

function onComplete(ctx: ChatRunContext): void {
  track('chat_run_outcome', {
    orgId: ctx.orgId,
    conversation_id: ctx.conversationId,
    outcome: 'success',
  });
  if (!ctx.suppressToast) {
    showChatRunCompleteToast({
      orgId: ctx.orgId,
      conversationId: ctx.conversationId,
    });
  }
}

function onFailed(ctx: ChatRunContext, reason: 'failed' | 'timeout'): void {
  logger.error(
    '[chatRunTracker] chat run ' + reason,
    new Error('chat run ' + reason),
    {
      component: 'reasoning',
      conversationId: ctx.conversationId,
      pollCount: ctx.pollCount,
    }
  );
  track('chat_run_outcome', {
    orgId: ctx.orgId,
    conversation_id: ctx.conversationId,
    outcome: reason,
  });
  if (!ctx.suppressToast) {
    showChatRunFailureToast({
      orgId: ctx.orgId,
      conversationId: ctx.conversationId,
      reason,
    });
  }
}

export const DEFAULT_CHAT_RUN_HANDLERS: ChatRunHandlers = {
  onComplete,
  onFailed,
};
